// extracted by mini-css-extract-plugin
export default {"headerNav":"HeaderNav_headerNav__cRZ--"};